import script from "./AutomotiveIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AutomotiveIndex.vue?vue&type=script&setup=true&lang=js"

import "./AutomotiveIndex.vue?vue&type=style&index=0&id=55214adf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55214adf"]])

export default __exports__